export default __webpack_public_path__ + "static/media/bolivia.38f604f2.svg";